import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import useManuallyUpdate from '../hooks/useManuallyUpdate';
import { dispatch } from '../redux/store';
import { RootState } from '../redux/root';
import { setHideCompleteActivitiesList } from '../redux/slices/projectSlice';

const CompletedToggle = () => {
  const [checked, setChecked] = useState<boolean>(false);
  const [tableManuallyUpdate, updateTable] = useManuallyUpdate();
  const hideCompleteActivities = useSelector((s: RootState) => s.projectsSlice.hideCompleteActivities);

  useEffect(() => {
    updateTable();
  }, [hideCompleteActivities]);

  const onClick = () => {
    setChecked(prev => !prev);
    dispatch(setHideCompleteActivitiesList(hideCompleteActivities + 1));
  };

  return (
    <TogglePill onClick={onClick} $active={checked}>
      <Track $active={checked}>
        <Thumb $active={checked} />
      </Track>
      {checked ? 'Completed Hidden' : 'Show All'}
    </TogglePill>
  );
};

export default CompletedToggle;

const TogglePill = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-1) var(--space-3) var(--space-1) var(--space-2);
  border: 1px solid ${({ $active }) => $active ? 'var(--primary-600)' : 'var(--neutral-300)'};
  border-radius: var(--radius-full);
  background: ${({ $active }) => $active ? 'var(--primary-50)' : 'var(--neutral-0)'};
  color: ${({ $active }) => $active ? 'var(--primary-700)' : 'var(--neutral-600)'};
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  font-family: inherit;
  cursor: pointer;
  transition: all var(--motion-fast) var(--ease-standard);

  &:hover {
    border-color: var(--primary-400);
    background: var(--primary-50);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;

const Track = styled.div<{ $active: boolean }>`
  width: 36px;
  height: 20px;
  border-radius: var(--radius-full);
  background: ${({ $active }) => $active ? 'var(--primary-600)' : 'var(--neutral-300)'};
  position: relative;
  transition: background-color var(--motion-fast) var(--ease-standard);
`;

const Thumb = styled.div<{ $active: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: var(--radius-full);
  background: var(--neutral-0);
  position: absolute;
  top: 2px;
  left: ${({ $active }) => $active ? '18px' : '2px'};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  transition: left var(--motion-fast) var(--ease-standard);
`;
